module.exports = __webpack_public_path__ + "img/img_tuijianguan@2x.271ca1b3.png";